
import React from "react";
import { Loader2 } from "lucide-react";

export const MentoriasLoadingState: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-32 bg-[#181D24] rounded-lg border border-[#222A35]">
      <div className="flex flex-col items-center">
        <Loader2 className="h-10 w-10 text-[#00B6F0] animate-spin mb-4" />
        <p className="text-gray-400">Carregando mentorias...</p>
      </div>
    </div>
  );
};
